import './SuccessMessage.scss';

export const SuccessMessage = () => {
  return (
    <div className="srf-comments-reply-form-success-message">
      <div className="srf-comments-reply-form-success-message-icon"></div>
      <div className="srf-comments-reply-form-success-message-text">
        Wir haben Ihren Kommentar erhalten und werden ihn nach Prüfung
        freischalten.
      </div>
    </div>
  );
};
